import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon, CaretCircleRightIcon } from '@phosphor-icons/react';

export default function NavigationCard({
  number,
  title,
  path,
  isActive = false,
  isCompleted = false,
  primaryColor,
  secondaryColor
}) {
  const navigate = useNavigate();

  // Helper function to convert hex to rgba
  const hexToRgba = (hex, alpha) => {
    if (!hex) return null;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  // State-based styling
  let bgStyle, textColor, arrowColor, bgClass;

  if (isActive) {
    // Active state: Primary color background, white text, primary icon
    bgStyle = { backgroundColor: primaryColor || '#2B4B8C' };
    bgClass = '';
    textColor = 'text-white';
    arrowColor = primaryColor || '#163F9B';
  } else if (isCompleted) {
    // Completed state: Secondary color background with opacity, gray text, primary checkmark
    bgStyle = { backgroundColor: hexToRgba(secondaryColor, 0.2) || 'rgba(217, 196, 125, 0.2)' };
    bgClass = '';
    textColor = 'text-gray-700';
    arrowColor = primaryColor || '#163F9B';
  } else {
    // Default state: Gray background with gray icon
    bgStyle = {};
    bgClass = 'bg-gray-100';
    textColor = 'text-gray-700';
    arrowColor = '#636363';
  }

  return (
    <div
      onClick={() => navigate(path)}
      style={bgStyle}
      className={`${bgClass} ${textColor} rounded-2xl p-4 flex items-center justify-between cursor-pointer hover:opacity-90 transition-opacity`}>
      <div className="flex items-center gap-3">
        <span className="font-semibold text-lg">{number}.</span>
        <span className="font-normal text-lg">{title}</span>
      </div>
      <div className="flex items-center justify-center">
        {isCompleted ? (
          <CheckCircleIcon size={34} weight="fill" color={arrowColor} />
        ) : (
          <CaretCircleRightIcon size={34} weight="fill" />
        )}
      </div>
    </div>
  );
}
